import styled from 'styled-components'

export const Container = styled.header`
  padding-bottom: 24px;

  > button {
    top: 16px;
    right: 16px;
  }
`
